export default __webpack_public_path__ + "static/media/product-analyses.1ee604d4.png";